module.exports = __webpack_public_path__ + "static/img/1-1.4d30cd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/1-1.png
// module id = FuBp
// module chunks = 0